import { MediaBlock as MediaBlockType } from '@/payload-types'
import { ImageComponent } from './imageComponent'
import { VideoComponent } from './videoComponent'
import { CaptionComponent } from './caption'
import Link from 'next/link'
interface IProps {
  mediaData: MediaBlockType
}

export const MediaComponent = ({ mediaData }: IProps) => {
  if (typeof mediaData.media === 'object') {
    const curMedia = mediaData.media

    if (!curMedia) return

    let mediaType = curMedia.mimeType
    mediaType = mediaType?.startsWith('image/')
      ? 'image'
      : mediaType?.startsWith('video/')
      ? 'video'
      : mediaType
    const ImageComponentRender = (
      <ImageComponent
        src={`${process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''}${
          mediaData.media.sizes?.webp?.url
        }`}
        alt={mediaData.altText ? mediaData.altText : mediaData.media.title}
        width={mediaData.media.sizes?.webp?.width}
        height={mediaData.media.sizes?.webp?.height}
      />
    )
    return (
      <>
        {(() => {
          switch (mediaType) {
            case 'image':
              return (
                <figure>
                  {mediaData.link ? (
                    <Link href={mediaData.link} target="_blank">
                      {ImageComponentRender}
                    </Link>
                  ) : (
                    <>{ImageComponentRender}</>
                  )}
                </figure>
              )
            case 'video':
              return <VideoComponent videoData={curMedia} />
            default:
              return null
          }
        })()}
        {mediaData.caption && <CaptionComponent captionData={mediaData.caption} />}
      </>
    )
  }
}

export default MediaComponent
